<!--  -->
<template>
    <div class='wrapper box box_v'>
        <!-- 头部标题 -->
        <page-head title="社区防疫提示" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
        <div class="content box box_f1">
            <Card style="width: 845px;margin:0 auto">
                <!-- 富文本编辑 -->
                <div class="editbox box_f1" ref="editview">
                    <editor-box
                        :height="editorHeight"
                        @editorContent="activityContent"
                        :content="lastContent"
                        >
                    </editor-box>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from '../../../components/head';
import editorBox from "../../../components/editorBox";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {pageHead,editorBox},
    data() {
    //这里存放数据
        return {
            btnList: [{
                name: '保存',
                type: 'fabu',
                loading: false,
            }],//头部按钮
            content:'',
            lastContent:'<p>居民朋友们：</p><p>大家新年好！</p><p>                如您是返京人员，请您本着对自己和他人健康负责的态度，自觉、及时联系社区居委会进行登记，并居家观察14天，期间尽量不接触其他人，注意个人卫生，保持住所通风良好，勤洗手，不随地吐痰，打喷嚏或咳嗽时用纸巾或袖肘遮住口鼻。如有发热、干咳等症状，请及时前往医院，并避免乘坐公共交通工具。</p>',
            editorHeight: "100%",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleBtn(type, index) {
            if (type == 'fabu') {
                this.submitFangyiNotice()
            }
        },
        activityContent(data) {
            this.content = data;
        },
        submitFangyiNotice(){
            console.log(this.content)
            this.btnList[0].loading = true
            this.$post(this.urlobj.getFangyiNotice,{
                message:this.content
            }).then(res=>{
                this.btnList[0].loading = false
                this.$Message.success('修改成功')
            }).catch(e=>{
                console.log(e)
            })
        },
        getFangyiNotice(){
            this.$get(this.urlobj.getFangyiNotice).then(res=>{
                this.lastContent= res.newPrimaryKeys.msg.replace(/\s/g, "&nbsp;");
                console.log(this.lastContent)
            }).catch(e=>{
                console.log(e)
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        // 减导航栏，标题栏，上下padding
        this.editorHeight = h - 60 - 84 - 20 - 20 + "px";
        this.getFangyiNotice()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
}

.content {
    margin: 0 20px 20px;
}
</style>
